import React, { useRef } from 'react';
import Button from '@cloudscape-design/components/button';
import Calendar from '@cloudscape-design/components/calendar';
import Input from '@cloudscape-design/components/input';
import Popover from '@cloudscape-design/components/popover';
import { formatDateDe, germanDateToIso, normalizeGermanDateInput } from '../utils/date';

export default function GermanDatePicker({ value, onChange, ariaLabel }) {
  const popoverRef = useRef(null);
  const selectedIsoDate = germanDateToIso(value) || '';

  function selectDate(isoDate) {
    onChange(formatDateDe(isoDate, ''));
    popoverRef.current?.dismiss();
  }

  return (
    <div className="german-date-picker">
      <Input
        ariaLabel={ariaLabel}
        inputMode="numeric"
        value={value}
        onChange={({ detail }) => onChange(normalizeGermanDateInput(detail.value))}
        placeholder="TT.MM.JJJJ"
      />
      <Popover
        ref={popoverRef}
        triggerType="custom"
        position="bottom"
        size="large"
        header="Datum auswählen"
        dismissAriaLabel="Kalender schließen"
        content={(
          <Calendar
            value={selectedIsoDate}
            locale="de-DE"
            startOfWeek={1}
            ariaLabel={ariaLabel}
            onChange={({ detail }) => selectDate(detail.value)}
            i18nStrings={{
              todayAriaLabel: 'Heute',
              nextMonthAriaLabel: 'Nächster Monat',
              previousMonthAriaLabel: 'Vorheriger Monat',
              currentMonthAriaLabel: 'Aktueller Monat',
              nextYearAriaLabel: 'Nächstes Jahr',
              previousYearAriaLabel: 'Vorheriges Jahr',
            }}
          />
        )}
      >
        <Button
          iconName="calendar"
          ariaLabel={`${ariaLabel}: Kalender öffnen`}
          formAction="none"
        />
      </Popover>
    </div>
  );
}
